import { Badge, BalanceText, ListItem, Text, Tooltip, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerLayoutProps } from '.';

export const Desktop: React.FC<CustomerLayoutProps> = ({
  backgroundColorBadge,
  balance,
  name,
  document,
  account,
  suitability,
  registrationStatus,
}) => {
  return (
    <HStack p={Spacing['inline.xxs']} alignItems="center" justifyContent="space-between">
      <ListItem testId="name" title="Nome">
        <Tooltip testID="name-tooltip" label={name}>
          <VStack>
            <Text>{name}</Text>
          </VStack>
        </Tooltip>
      </ListItem>
      <ListItem testId="document" title="CPF/CNPJ">
        {document}
      </ListItem>
      <ListItem testId="account" title="Conta">
        {account}
      </ListItem>
      <ListItem testId="suitability" title="Suitability">
        <Badge testId="suitability-profile-name" backgroundColor={backgroundColorBadge}>
          {suitability}
        </Badge>
      </ListItem>
      <ListItem testId="registration-status" title="Situação cadastral">
        {registrationStatus}
      </ListItem>
      <VStack alignItems="end">
        <Text variant="semibold" lineHeight="distant" pr={Spacing['inline.nano']}>
          Saldo disponível
        </Text>
        <BalanceText
          balance={balance.available}
          isUpdating={balance.isLoading}
          onUpdateButtonPress={balance.onUpdateButton}
          lastUpdatedAt={balance.lastUpdatedAt}
          hasUpdateButton
          textAlign="flex-end"
          positiveBalanceColor="neutral.black"
          negativeBalanceColor="feedback.error.default"
        />
      </VStack>
      <VStack alignItems={'flex-end'} w={'130px'}>
        <Text fontSize={Typography['fontsize.md']} variant="semibold">
          Saldo estimado
        </Text>
        <Box alignItems="flex-end">
          <Text
            fontSize={Typography['fontsize.md']}
            numberOfLines={1}
            {...(balance.estimated.startsWith('-') && { color: 'feedback.error.default' })}>
            {balance.estimated}
          </Text>
          <Text color="neutral.light" fontSize={Typography['fontsize.xs']}>
            Após investimento
          </Text>
        </Box>
      </VStack>
    </HStack>
  );
};
